<script setup>
</script>

<style>

</style>

<template>
    <label class="text-[#344054] text-[14px] font-medium">
        <slot></slot>
    </label>
</template>
